// ConvertToCanon/artstyles/MinimalismStyle.js
export const applyMinimalismStyle = async (canvas, ctx, setMessage, language) => {
  // 미니멀리즘: 단순화와 절제
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 극도로 단순화된 색상 팔레트
  const palette = [255, 200, 100, 50, 0];
  
  for (let i = 0; i < data.length; i += 4) {
    const gray = (data[i] + data[i + 1] + data[i + 2]) / 3;
    let closestColor = palette[0];
    let minDiff = Math.abs(gray - closestColor);
    
    for (const color of palette) {
      const diff = Math.abs(gray - color);
      if (diff < minDiff) {
        minDiff = diff;
        closestColor = color;
      }
    }
    
    data[i] = data[i + 1] = data[i + 2] = closestColor;
  }
  
  ctx.putImageData(imageData, 0, 0);
};